import React, {Component, createRef} from 'react';
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import Window from "../../../../lib/components/window/Window";
import SettingsItem from './SettingsItem';
import Template_Dark from '../../../../lib/fonts/icons/Template_Darkmode.svg';
import Domain_Dark from '../../../../lib/fonts/icons/Domain_Darkmode.svg';
import Privilege_Image from '../../../../lib/fonts/icons/Privilege_Image.png';
import HorizontalTabBar from '../tabbar/HorizontalTabBar';
import VerticalLayout from '../../../../lib/components/layouts/VerticalLayout';
import BaseTab from '../tabbar/BaseTab';
import TableButtonGroup from '../entity/tableButtonGroup/TableButtonGroup';
import Entity from '../entity/Entity';
import EntityDescribe from '../../../../lib/model/service/entity/dto/EntityDescribe';
import CM from '../../../model/system/CM';
import DataSource from '../../../../lib/model/service/dataSource/DataSource';
import {toast} from 'react-toastify';

class Settings extends Component {

  static entityNameCampaignTemplate = 'appl\\models\\entity\\doctrine\\CampaignTemplate';
  static entityNameSysDomain = 'po2\\system\\db\\doctrine\\entity\\SysDomain';
  static entityNameSysPrivilege = 'po2\\system\\db\\doctrine\\entity\\SysPrivilege';

  constructor(props) {
    super(props);
    this.horizontalTabBarRef = createRef();
    this.state = {
      datasources: {},
      tabIds: {},
    };
    this.initDatasources();
  }

  initDatasources() {
    this.initDatasource(Settings.entityNameCampaignTemplate);
    this.initDatasource(Settings.entityNameSysDomain);
    this.initDatasource(Settings.entityNameSysPrivilege);
  }

  initDatasource(entityName) {
    CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), new EntityDescribe([entityName]), (response) => {
      this.state.datasources[entityName] = this.generateDataSource(response);
    });
  }

  generateDataSource(response) {
    let dataSource = null;
    if (response.success) {
      dataSource = DataSource.generateDatasource(response.data.serviceDescription.entityDefs[0], null,
        (datasource, dto, dataSourceDtoProcessEvents) => {
          CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), dto, (response) => {
            dataSourceDtoProcessEvents.doResponse(response);
          });
        });
    } else {
      toast.error(response.message);
    }
    return dataSource;
  }

  addTableToTab(entityName, title) {
    if (this.state.datasources[entityName]) {

      this.state.tabIds[entityName] = this.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={title} notClosable/>, <Entity headerButtons={<TableButtonGroup ref={createRef()} editable tableName={entityName}/>}
                                                                                                                               parent={this} dataSource={this.state.datasources[entityName]}/>, entityName);
    } else {
      setTimeout(() => {
        this.addTableToTab(entityName, title);
      }, 500);
    }
  }

  onTemplateClick(event) {
    this.addTableToTab(Settings.entityNameCampaignTemplate, 'Templates');
  }

  onDomainClick(event) {
    this.addTableToTab(Settings.entityNameSysDomain, 'Domäne');
  }

  onPrivilegeClick(event) {
    this.addTableToTab(Settings.entityNameSysPrivilege, 'Privilegien');
  }

  render() {
    return <VerticalLayout>
      <Window className='text-cn-color-white'>
        <HorizontalLayout className='justify-center flex-wrap'>
          <SettingsItem title='Templates' img={<img src={Template_Dark} className='p-8' alt='Templates'/>} onClick={(event) => this.onTemplateClick(event)}/>
          <SettingsItem title='Domänen' img={<img src={Domain_Dark} className='p-8' alt='Domänen'/>} onClick={(event) => this.onDomainClick(event)}/>
          <SettingsItem title='Privilegien' img={<img src={Privilege_Image} className='p-8' alt='Privilegien'/>} onClick={(event) => this.onPrivilegeClick(event)}/>
        </HorizontalLayout>
      </Window>
      <HorizontalTabBar className='CNINFO-Settings-TabContainer h-full p-2' ref={this.horizontalTabBarRef}/>
    </VerticalLayout>
  }
}

export default Settings;
